export interface FieldPersonnel {
  id: string;
  name: string;
  roleLabel: string;
  email: string;
  credentialHint?: string;
  team: string;
  telegramStatus: string;
}

export const ACCOUNTS_PERSONNEL_QUERY_KEY = 'personnel';
export const MICHELLE_ADDINGTON_PERSONNEL_ID = 'michelle-addington';
export const JEHUVIN_RICHARDS_PERSONNEL_ID = 'jehuvin-richards';
export const JOHN_SMITH_PM_PERSONNEL_ID = 'john-smith';
export const SARAH_JOHNSON_PM_PERSONNEL_ID = 'sarah-johnson';

export type AccountsFieldPersonnel = FieldPersonnel;
export type PmFieldPersonnel = FieldPersonnel;
export type RoleFieldPersonnel = FieldPersonnel;

const PASSWORD_ACCOUNTS = 'Password: Accounts@123';
const PASSWORD_CONSTRUCTION = 'Password: Construct@123';
const PASSWORD_EXECUTIVE = 'Password: Exec@123';
const PASSWORD_FIELD_ADMIN = 'Password: FieldAdmin@123';
const PASSWORD_PM = 'Password: PM@123';
const PASSWORD_PROCUREMENT = 'Password: Procure@123';
const PASSWORD_QS = 'Password: QS@123';
const PASSWORD_STORES = 'Password: Stores@123';
const PASSWORD_SUPERVISOR = 'Password: Super@123';

export const accountsFieldPersonnel: AccountsFieldPersonnel[] = [
  {
    id: MICHELLE_ADDINGTON_PERSONNEL_ID,
    name: 'Michelle Addington',
    roleLabel: 'Accounts personnel',
    email: 'interplanja@gmail.com',
    credentialHint: PASSWORD_ACCOUNTS,
    team: 'Accounts Team',
    telegramStatus: 'Telegram linked',
  },
  {
    id: JEHUVIN_RICHARDS_PERSONNEL_ID,
    name: 'Jehuvin Richards',
    roleLabel: 'Accounts personnel',
    email: 'jrichards@fairmont.com',
    credentialHint: PASSWORD_ACCOUNTS,
    team: 'Accounts Team',
    telegramStatus: 'Telegram not linked',
  },
];

export const pmFieldPersonnel: PmFieldPersonnel[] = [
  {
    id: JOHN_SMITH_PM_PERSONNEL_ID,
    name: 'John Smith',
    roleLabel: 'Project manager',
    email: 'john.smith@fairmont.com',
    credentialHint: PASSWORD_PM,
    team: 'Project Management',
    telegramStatus: 'Telegram not linked',
  },
  {
    id: SARAH_JOHNSON_PM_PERSONNEL_ID,
    name: 'Sarah Johnson',
    roleLabel: 'Project manager',
    email: 'pm2@fairmont.com',
    credentialHint: PASSWORD_PM,
    team: 'Project Management',
    telegramStatus: 'Telegram not linked',
  },
];

export const supervisorFieldPersonnel: RoleFieldPersonnel[] = [
  {
    id: 'supervisor-william-rodriguez',
    name: 'William Rodriguez',
    roleLabel: 'Supervisor',
    email: 'william.rodriguez@fairmont.com',
    credentialHint: PASSWORD_SUPERVISOR,
    team: 'Supervisor Team',
    telegramStatus: 'Telegram not linked',
  },
  {
    id: 'supervisor-lisa-anderson',
    name: 'Lisa Anderson',
    roleLabel: 'Supervisor',
    email: 'supervisor2@fairmont.com',
    credentialHint: PASSWORD_SUPERVISOR,
    team: 'Supervisor Team',
    telegramStatus: 'Telegram not linked',
  },
];

export const storesFieldPersonnel: RoleFieldPersonnel[] = [
  {
    id: 'stores-michael-brown',
    name: 'Michael Brown',
    roleLabel: 'Stores personnel',
    email: 'michael.brown@fairmont.com',
    credentialHint: PASSWORD_STORES,
    team: 'Stores Team',
    telegramStatus: 'Telegram not linked',
  },
  {
    id: 'stores-emily-davis',
    name: 'Emily Davis',
    roleLabel: 'Stores personnel',
    email: 'stores2@fairmont.com',
    credentialHint: PASSWORD_STORES,
    team: 'Stores Team',
    telegramStatus: 'Telegram not linked',
  },
];

export const procurementFieldPersonnel: RoleFieldPersonnel[] = [
  {
    id: 'procurement-richard-moore',
    name: 'Richard Moore',
    roleLabel: 'Procurement personnel',
    email: 'procurement1@fairmont.com',
    credentialHint: PASSWORD_PROCUREMENT,
    team: 'Procurement Team',
    telegramStatus: 'Telegram not linked',
  },
  {
    id: 'procurement-jessica-jackson',
    name: 'Jessica Jackson',
    roleLabel: 'Procurement personnel',
    email: 'procurement2@fairmont.com',
    credentialHint: PASSWORD_PROCUREMENT,
    team: 'Procurement Team',
    telegramStatus: 'Telegram not linked',
  },
];

export const qsFieldPersonnel: RoleFieldPersonnel[] = [
  {
    id: 'qs-quantity-surveyor',
    name: 'Quantity Surveyor',
    roleLabel: 'Quantity surveyor',
    email: 'quantity.surveyor@fairmont.com',
    credentialHint: PASSWORD_QS,
    team: 'Quantity Surveying',
    telegramStatus: 'Telegram not linked',
  },
];

export const constructionLoginPersonnel: RoleFieldPersonnel[] = [
  {
    id: 'construction-david-wilson',
    name: 'David Wilson',
    roleLabel: 'Construction worker login',
    email: 'david.wilson@fairmont.com',
    credentialHint: PASSWORD_CONSTRUCTION,
    team: 'Construction Team',
    telegramStatus: 'Telegram not linked',
  },
  {
    id: 'construction-james-martinez',
    name: 'James Martinez',
    roleLabel: 'Construction worker login',
    email: 'construction2@fairmont.com',
    credentialHint: PASSWORD_CONSTRUCTION,
    team: 'Construction Team',
    telegramStatus: 'Telegram not linked',
  },
  {
    id: 'construction-robert-garcia',
    name: 'Robert Garcia',
    roleLabel: 'Construction worker login',
    email: 'construction3@fairmont.com',
    credentialHint: PASSWORD_CONSTRUCTION,
    team: 'Construction Team',
    telegramStatus: 'Telegram not linked',
  },
];

export const executiveFieldPersonnel: RoleFieldPersonnel[] = [
  {
    id: 'executive-margaret-reid',
    name: 'Margaret Reid',
    roleLabel: 'Executive',
    email: 'executive1@fairmont.com',
    credentialHint: PASSWORD_EXECUTIVE,
    team: 'Executive',
    telegramStatus: 'Telegram not linked',
  },
];

export const fieldAdminPersonnel: RoleFieldPersonnel[] = [
  {
    id: 'field-admin-martin-addington',
    name: 'Martin Addington',
    roleLabel: 'Field admin',
    email: 'martin@interplanja.com',
    credentialHint: PASSWORD_FIELD_ADMIN,
    team: 'Admin',
    telegramStatus: 'Telegram not linked',
  },
];

export const seededFieldLoginRows: FieldPersonnel[] = [
  ...pmFieldPersonnel,
  ...storesFieldPersonnel,
  ...constructionLoginPersonnel,
  ...supervisorFieldPersonnel,
  ...accountsFieldPersonnel,
  {
    id: 'accounts-jennifer-taylor',
    name: 'Jennifer Taylor',
    roleLabel: 'Accounts personnel',
    email: 'accounts1@fairmont.com',
    credentialHint: PASSWORD_ACCOUNTS,
    team: 'Accounts Team',
    telegramStatus: 'Telegram not linked',
  },
  {
    id: 'accounts-daniel-thomas',
    name: 'Daniel Thomas',
    roleLabel: 'Accounts personnel',
    email: 'accounts2@fairmont.com',
    credentialHint: PASSWORD_ACCOUNTS,
    team: 'Accounts Team',
    telegramStatus: 'Telegram not linked',
  },
  ...procurementFieldPersonnel,
  ...qsFieldPersonnel,
  ...executiveFieldPersonnel,
  ...fieldAdminPersonnel,
];

export const accountsFieldPersonnelById = (id?: string | null) =>
  accountsFieldPersonnel.find((person) => person.id === id) ?? null;

export const pmFieldPersonnelById = (id?: string | null) =>
  pmFieldPersonnel.find((person) => person.id === id) ?? null;

export const fieldPersonnelById = (rows: FieldPersonnel[], id?: string | null) =>
  rows.find((person) => person.id === id) ?? null;
